var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2BA8E8",
    fillRule: "evenodd",
    d: "M30.053.245a4.05 4.05 0 015.192 5.19l-8.935 26.78a4.05 4.05 0 01-2.92 2.672 4.001 4.001 0 01-3.8-1.084l-4.795-4.773-5.035 2.605a1.25 1.25 0 01-1.825-1.143l.208-7.96L25.755 9.74a1.564 1.564 0 10-1.837-2.53L6.008 20.22l-4.325-4.325A4 4 0 01.59 12.278a4.05 4.05 0 012.673-3.096h.007L30.05.242l.003.003z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend02);
export default ForwardRef;